import { FC } from 'react';
import Markdown from 'react-markdown';
import { CardV2 } from 'src/shared/ui/_layout/CardV2';
import { HeadingV2 } from 'src/shared/ui/_text/HeadingV2';
import { Area } from '../../_BLL/types';
import s from './Content.module.scss';
import supersub from 'remark-supersub';

interface Props {
	area: Area;
}

export const Content: FC<Props> = (props) => {
	const {
		area: { recommendationParts },
	} = props;

	return (
		<CardV2
			className={s.container}
			variant="primary"
		>
			<HeadingV2
				type="h3_bold"
				color="light"
				tag="div"
			>
				Denominator<sup>AI Insights</sup>
			</HeadingV2>

			{recommendationParts.map(({ name, recommendationText }) => (
				<div key={name}>
					<HeadingV2
						className={s.heading}
						type="h1"
						color="main"
						underline
						marginBottom="m"
					>
						{name}
					</HeadingV2>

					<div className={s.markdown}>
						<Markdown remarkPlugins={[supersub]}>{recommendationText}</Markdown>
					</div>
				</div>
			))}
		</CardV2>
	);
};
